module.exports = __webpack_public_path__ + "ax.svg?f8c4019f81d13aade8e732ab4a6baf32";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/ax.svg
// module id = 1238
// module chunks = 0